<template>
  <div>
    <breadcrumbs home="Customer portal"/>

    <v-card flat>
      <v-tabs :vertical="!$vuetify.breakpoint.mobile" show-arrows>

        <template v-if="permissions.includes('config.write')">
          <v-tab>Customers</v-tab>
          <v-tab-item>
            <apps-portal-customers :portalCustomers="portalCustomers" v-model="customerId"/>
          </v-tab-item>
        </template>

        <template>
          <v-tab :disabled="!permissions.includes('inventory')">Inventory</v-tab>
          <v-tab-item>
            <apps-portal-inventory :portalCustomers="portalCustomers" v-model="customerId"/>
          </v-tab-item>
        </template>

        <template>
          <v-tab :disabled="!permissions.includes('production')">Production</v-tab>
          <v-tab-item>
            <apps-portal-production :portalCustomers="portalCustomers" v-model="customerId"/>
          </v-tab-item>
        </template>

        <template>
          <v-tab>Documents</v-tab>
          <v-tab-item>
            <apps-portal-documents :portalCustomers="portalCustomers" v-model="customerId"/>
          </v-tab-item>
        </template>

        <template>
          <v-tab>Message</v-tab>
          <v-tab-item>
            <apps-portal-message />
          </v-tab-item>
        </template>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import AppsPortalCustomers from '@/views/apps/portal/AppsPortalCustomers'
import AppsPortalInventory from '@/views/apps/portal/AppsPortalInventory'
import AppsPortalProduction from '@/views/apps/portal/AppsPortalProduction'
import AppsPortalMessage from '@/views/apps/portal/AppsPortalMessage'
import AppsPortalDocuments from '@/views/apps/portal/AppsPortalDocuments'

export default {
  name: 'AppsPortal',
  components: {AppsPortalCustomers,AppsPortalInventory,AppsPortalProduction,AppsPortalMessage,AppsPortalDocuments},
  data() {
    return {
      portalCustomers: [],
      customerId: ''
    }
  },
  computed: {
    permissions() {
      return this.$store.getters.company.permissions;
    }
  },
  async created() {
    const results = await this.$apiCall(`query AppsPortal {
                                          portalCustomers {customerId,customerName}
                                        }`,
                                        {}, false, 'portal');
    if (!results.error)
      this.portalCustomers = results.data.portalCustomers;

    if (!this.customerId)
      this.customerId = this.portalCustomers?.[0]?.customerId ?? '';
  },
  methods: {
  }
}
</script>